import { Controller } from 'stimulus'

export default class MainEmailController extends Controller {
  static targets = ['mainEmail', 'button']

  connect() {
    this.verify()
  }

  verify() {
    const input = $(this.mainEmailTarget)
    const button = $(this.buttonTarget)
    const current = input.data('current')
    button.prop('disabled', input.val() === current)
  }
}
